var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrappersss"},[(_vm.bfundType === '0')?_c('FixIncomeList'):_vm._e(),(_vm.bfundType === '1')?_c('FixNoIncomeList'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }